import { api, unwrap } from "../lib/axios";
import type { ApiEnvelope } from "../types/api";
import type { DashboardAnalytics, DashboardPeriod } from "../types/admin";

export const dashboardApi = {
  async get(period: DashboardPeriod): Promise<DashboardAnalytics> {
    const res = await api.get<ApiEnvelope<DashboardAnalytics>>(
      "/admin/analytics/dashboard",
      { params: { period } },
    );
    return unwrap(res);
  },
};
